import React from 'react';
import { CostConfirmBar, Field, GenerateButton, ToVerifyBadge, type StepProps } from './shared';

const BriefStep: React.FC<StepProps> = ({
  dossier,
  isRunning,
  costEstimate,
  showCostConfirm,
  onRequestGenerate,
  onConfirmGenerate,
  onCancelGenerate,
}) => {
  const brief = dossier?.brief ?? null;
  const isLlm = brief?.source === 'llm_generated';

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-semibold text-slate-700">Step 1 — Industrialization Brief</h3>
        {showCostConfirm ? (
          <CostConfirmBar
            costEstimate={costEstimate}
            confirmLabel="Generate Brief"
            onConfirm={onConfirmGenerate}
            onCancel={onCancelGenerate}
          />
        ) : (
          <GenerateButton label="Generate Brief" isRunning={isRunning} onRequest={onRequestGenerate} />
        )}
      </div>

      {brief ? (
        <div className="space-y-2 text-xs text-slate-700">
          <Field label="Target volumes" value={brief.target_volumes} toVerify={isLlm} />
          <Field label="In-house intent" value={brief.in_house_intent} toVerify={isLlm} />
          <Field label="Cost/lead-time priorities" value={brief.cost_lead_priorities} toVerify={isLlm} />

          {(brief.suspected_problem_parts?.length ?? 0) > 0 && (
            <div>
              <span className="font-medium text-slate-500">Suspected problem parts: </span>
              {isLlm && <ToVerifyBadge />}
              <ul className="mt-1 ml-3 list-disc space-y-0.5">
                {brief.suspected_problem_parts.map((p, i) => <li key={i}>{p}</li>)}
              </ul>
            </div>
          )}

          {brief.summary && (
            <div className="mt-2 p-2 bg-slate-50 rounded border border-slate-200">
              <span className="font-medium text-slate-500 block mb-1">
                Summary {isLlm && <ToVerifyBadge />}
              </span>
              <p className="text-slate-600 leading-relaxed">{brief.summary}</p>
            </div>
          )}
        </div>
      ) : (
        <p className="text-xs text-slate-400 italic">
          {isRunning ? 'Generating brief…' : 'No brief yet. Click "Generate Brief" to start.'}
        </p>
      )}
    </div>
  );
};

export default BriefStep;
